import "./logisticsDrawer.css";

import { Drawer } from "@mui/material";
import { lazy, Suspense, useEffect, useState } from "react";

// lazy loading for the components

const LOGISTICS_PAGES = {
  LOGISTICS_HOME: {
    component: lazy(() => import("../../../../ecommerce/ThirdPartyLogistics/index.js")),
    header: "",
    subHeader: "",
  },
};

const LogisticsDrawer = ({ open, onClose }) => {
  // this is used to save the current page and navigate to the back page

  const [pageStack, setPageStack] = useState([{ page: "LOGISTICS_HOME", data: null }]);

  useEffect(() => {
    if (open) {
      setPageStack([{ page: "LOGISTICS_HOME", data: null }]);
    }
  }, [open]);

  //   --------------------for navigate next and back -------------
  const navigate = (page, data = null) => {
    setPageStack((prev) => [...prev, { page, data }]);
  };

  // go back
  const goBack = () => {
    setPageStack((prev) => prev.slice(0, -1));
  };

  //   define the current page and current component --------------------
  const currentPageObj = pageStack[pageStack?.length - 1];
  const currentPage = currentPageObj?.page;
  const pageData = currentPageObj?.data;

  const CurrentPageConfig = LOGISTICS_PAGES[currentPage];

  const CurrentComponent = CurrentPageConfig?.component;
  const header = pageData?.header || CurrentPageConfig?.header;
  const subHeader = pageData?.subHeader || CurrentPageConfig?.subHeader;

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      //   PaperProps={{ className: "hold-drawer-paper" }}
    >
      <main className="logistics-main-container">
        {/* navbar comes here */}
        <div className="logistics-body-wrapper">
          {/* session components */}
          <Suspense fallback={<div>Loading...</div>}>
            <CurrentComponent navigate={navigate} {...(pageData || {})} />
          </Suspense>

          {/* footer section */}
        </div>
      </main>
    </Drawer>
  );
};

export default LogisticsDrawer;
